import store from '@/store';
import growthBook from 'services/growthBook';
import {
  isPriceWithoutFeesVariantValue,
  priceWithoutFeesFeatureKey,
} from './priceWithoutFeesExperiment';

/**
 * The same INS-1288 A/B assignment as `usePriceWithoutFeesVariant`, read outside React for the
 * price sort in `utils/tripFilters`.
 *
 * It lives in its own module for one concrete reason: reaching the assignment without hooks
 * needs the Redux store singleton, and the store's import graph pulls in connected containers.
 * Component suites that mock `react-redux` down to `useSelector` fail to even load a module
 * that reaches it — so keeping this out of `priceWithoutFeesExperiment` is what lets components
 * import the rule without dragging the store in behind it. The key and the true-only
 * normalisation are imported from there, so the two readers cannot drift apart.
 *
 * Call it once per sort and pass the result down, never once per comparison: the answer cannot
 * change inside a single sort, and GrowthBook would re-run its hashing on every pair.
 *
 * @param {boolean} hasDisplayTotal - Whether any trip in the list carries a display total.
 * @returns {boolean} Whether to sort on the reduced display total.
 */
export const isPriceWithoutFeesVariantActive = (hasDisplayTotal) => {
  if (!hasDisplayTotal) return false;
  if (!growthBook.isInitialized()) return false;

  const { brand } = store.getState().whitelabelConfig.env;
  // Same guard as the hook: without a brand the key is not this tenant's feature.
  if (!brand) return false;

  return isPriceWithoutFeesVariantValue(
    growthBook.getInstance().getFeatureValue(priceWithoutFeesFeatureKey(brand)),
  );
};

export default isPriceWithoutFeesVariantActive;
